// extracted by mini-css-extract-plugin
export var container = "RiskSnapshot-module--container--CDlwl";
export var headline = "RiskSnapshot-module--headline--4d+co";
export var imagesList = "RiskSnapshot-module--imagesList--sUd-Z";
export var overline = "RiskSnapshot-module--overline--wFcgG";
export var risk = "RiskSnapshot-module--risk--fRrob";